import { render, staticRenderFns } from "./InvoiceCustomApprovalTypeCreateEdit.vue?vue&type=template&id=0c3adb72&scoped=true&"
import script from "./InvoiceCustomApprovalTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceCustomApprovalTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCustomApprovalTypeCreateEdit.vue?vue&type=style&index=0&id=0c3adb72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3adb72",
  null
  
)

export default component.exports